import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="calc-working-hours"
export default class extends Controller {
  static targets = [
    'workingGenerell',
    'levelOfEmployment',
    'weeklyWorkingHours'
  ]

  connect () {
    // console.log('calc-working-hours#connect')
  }

  calc (evt) {
    // console.log('calc-working-hours#calc', evt)

    const working_generell = parseFloat(this.workingGenerellTarget.value.replace(/[',]/g, ''))
    const level_of_employment = parseFloat(this.levelOfEmploymentTarget.value.replace(/[',]/g, ''))
    const weekly_working_hours = parseFloat(this.weeklyWorkingHoursTarget.value.replace(/[',]/g, ''))

    if( working_generell <= 0.0 ) return
    if( level_of_employment <= 0.0 ) return
    // if( weekly_working_hours > 0.0 ) return

    this.weeklyWorkingHoursTarget.value =
      working_generell * level_of_employment / 100.0
  }
}
